export interface CompanionColorOption {
  readonly name: string;
  readonly className: string;
  readonly darkCheck?: boolean;
}

// Array order is the backend/iOS SensorColor raw value (0 through 7).
export const COMPANION_COLOR_OPTIONS: readonly CompanionColorOption[] = [
  {name: "Yellow", className: "yellow-background", darkCheck: true},
  {name: "Green", className: "green-background"},
  {name: "Red", className: "red-background"},
  {name: "Blue", className: "blue-background"},
  {name: "Orange", className: "orange-background"},
  {name: "Violet", className: "violet-background"},
  {name: "White", className: "white-background", darkCheck: true},
  {name: "Gray", className: "gray-background"},
];
